import { call, put } from "redux-saga/effects";
import { getAllCategories } from "../../api/categoryApi";
import { Types } from "../actionTypes";

export function* getCategories(action) {
  try {
    const data = yield call(getAllCategories, action);
    yield put({ type: Types.FETCHING_CATEGORIES_SUCCESS, data });
  } catch (error) {
    yield put({ type: Types.FETCHING_CATEGORIES_FAILURE });
    if (error.data?.message === "SESSION_EXPIRED") {
      yield put({ type: Types.SET_SESSION_EXPIRED });
    }
    console.error("Saga Error: " + error);
  }
}
